import { combineReducers } from "redux";

import category from "../features/admin/categorys/category/Slice";

import product from "../features/admin/categorys/product/Slice";

import platform from "../features/admin/categorys/platform/Slice";

import project from "../features/admin/categorys/project/Slice";

import location from "../features/admin/categorys/location/Slice";

import projectstatus from "../features/admin/categorys/project_status/Slice";

import keybenefit from "../features/admin/categorys/key_benefit/Slice";

import amenity from "../features/admin/categorys/amenity/Slice";

import common from "../features/admin/common/Slice";

const categorys = combineReducers({
    category,
    product,
    platform,
    project,
    location,
    projectstatus,
    keybenefit,
    amenity,
    common
});

export default categorys;